import { render, staticRenderFns } from "./app-role.vue?vue&type=template&id=1a0e8086&scoped=true&"
import script from "./app-role.vue?vue&type=script&lang=js&"
export * from "./app-role.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0e8086",
  null
  
)

export default component.exports